import { toPercent } from 'pano-utils';
import OSS from 'ali-oss';
import type { PVTaskRespData } from '@types';
import { taskStartApi } from './taskApis';

export default async function panoVideoUpload(
  file: File,
  task: PVTaskRespData,
  onProgress: (progress: string) => void
) {
  const client = new OSS({
    accessKeyId: task.accessKeyId,
    accessKeySecret: task.accessKeySecret,
    stsToken: task.securityToken,
    bucket: task.bucketName,
    endpoint: task.endpointO,
    secure: true,
  });
  await client.multipartUpload(task.key, file, {
    progress: (p) => {
      onProgress(toPercent(p));
    },
  });
  await taskStartApi(task.taskId);
  onProgress('制作中');
}
